(() => {
  const header = document.querySelector('[data-hatch-header]');
  const menu = document.querySelector('[data-hatch-menu]');
  const open = document.querySelector('[data-hatch-menu-open]');
  const close = document.querySelector('[data-hatch-menu-close]');
  let previousOverflow = '';
  let lastScroll = window.scrollY;
  const syncHeader = () => {
    const y = window.scrollY;
    header?.classList.toggle('is-scrolled', y > 120);
    if (y < 160 || y < lastScroll - 2) header?.classList.remove('is-hidden');
    else if (y > lastScroll + 2 && !menu?.open) header?.classList.add('is-hidden');
    lastScroll = y;
  };
  syncHeader();
  window.addEventListener('scroll', syncHeader, { passive: true });
  if (!menu || !open || !close) return;
  const closeMenu = () => { menu.close(); };
  open.addEventListener('click', () => {
    previousOverflow = document.body.style.overflow;
    menu.showModal(); open.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden'; close.focus();
  });
  close.addEventListener('click', closeMenu);
  menu.addEventListener('click', e => {
    if (e.target === menu || e.target.closest('a')) closeMenu();
  });
  menu.addEventListener('close', () => {
    open.setAttribute('aria-expanded','false'); document.body.style.overflow = previousOverflow; open.focus();
  });
  window.addEventListener('resize', () => { if(window.innerWidth > 767 && menu.open) closeMenu(); });
})();

